import { render, staticRenderFns } from "./RegionDeliveryLabel.vue?vue&type=template&id=350d586c&scoped=true&"
import script from "./RegionDeliveryLabel.vue?vue&type=script&lang=js&"
export * from "./RegionDeliveryLabel.vue?vue&type=script&lang=js&"
import style0 from "./RegionDeliveryLabel.vue?vue&type=style&index=0&id=350d586c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350d586c",
  null
  
)

export default component.exports